import { ref } from 'vue';

const isOpen = ref(false);

export function useMascotAssistant() {
  function toggle() {
    isOpen.value = !isOpen.value;
  }
  function open() {
    isOpen.value = true;
  }
  function close() {
    isOpen.value = false;
  }
  return {
    isOpen,
    toggle,
    open,
    close,
  };
}
